import * as actionTypes from '../../actionTypes';
import {moduleTypes} from '../../../util/constants';
import {isManagement,getCompanyId} from '../../../util/customMethods';
import {getAccessToken} from '../../authenticateActions'
import {getAxiosInstance} from '../../../util/service';
export const retrieveDriverReport=(obj,status)=>{
    return async (dispatch) => {
        try{
            const _url =`/driverPerformanceSummary/${obj.idCompany}/${status}?access_token=${getAccessToken()}&fromDate=${obj.fromDate}&toDate=${obj.toDate}`;
            const response=await getAxiosInstance(moduleTypes.REPORT).get(_url);
            if(response.status===200){
                dispatch({type:actionTypes.GET_DRIVER_PERFORMANCE_SUM,driverPerformanceData:response.data.response||[]})
            }else{
                dispatch({type:actionTypes.GET_DRIVER_PERFORMANCE_SUM,driverPerformanceData:undefined})
            }
            return {statusCode:response.data.statusCode,statusMsg:response.data.statusMsg}
        }catch(ex){
            dispatch({type:actionTypes.GET_DRIVER_PERFORMANCE_SUM,driverPerformanceData:undefined})
            return {statusCode:500,statusMsg:'An unexpected error occurred.'}
        }
    }
}
export const cleanDriverPerReport=()=>{
    return async (dispatch) => {
           dispatch({type:actionTypes.GET_DRIVER_PERFORMANCE_SUM,driverPerformanceData:undefined})
    }
}
export const emailDriverPerformanceSum=(obj,status)=>{
    return async (dispatch) => {
        try{
            const _url =`/eMailDriverPerformanceSummary/${obj.idCompany}/${status}?access_token=${getAccessToken()}&fromDate=${obj.fromDate}&toDate=${obj.toDate}`;
            const response=await getAxiosInstance(moduleTypes.REPORT).get(_url);
            return {statusCode:response.data.statusCode,statusMsg:response.data.message}
        }catch(ex){
            dispatch({type:actionTypes.GET_DRIVER_PERFORMANCE_SUM,driverPerformanceData:undefined})
            return {statusCode:500,statusMsg:'An unexpected error occurred.'}
        }
    }
}